import { Form } from 'antd-mobile';
import { getRules } from './util';
import { getForm } from './util';

//form.item里面不能存在其他标签，所以用函数代替标签写法
const DynamicForm = (props) => {
    return (
        <>
            {
                props.field_type === 3  || 
                (props.field_type === 2 && props.setting?.type === 'multiple')? getForm(props)
                :
                <Form.Item label={props.label === undefined ? props.name : props.label} name={props.en_name} 
                    rules={getRules(props)}
                    layout={props.field_type === 5 && props.setting?.type === 'range' ?'vertical':'horizontal'}
                    childElementPosition={props.field_type === 5 && props.setting?.type === 'range' ?'normal':'right'}
                >
                    {getForm(props)}
                </Form.Item>
            }
        </>
    );
};
export default DynamicForm;
